// 自动引入API URL 导出默认带上Ser后缀
import request from './request'
const modulesFiles = require.context('./modules', false, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName + 'Ser'] = value.default
    return modules
}, {})
modules.request = request
export default modules
